import { Pipe, PipeTransform, inject } from '@angular/core';
import {DateTime} from 'luxon';
import {APP_CONFIG} from 'src/app/app.config';
import {IAppConfig} from 'src/app/app-config.interface';

/**
 *  Pipe that defaults to our AppConfig settings
 *  @see AppConfig
 */

@Pipe({
  name: 'dateTimeFormat',
  standalone: true,
})
export class DateTimeFormatPipe implements PipeTransform {
  config = inject<IAppConfig>(APP_CONFIG);


  transform(date: any, format: string = this.config.dateFormat): any {
    if (date) {
      if (format === 'withtime') {
        format = this.config.dateTimeFormat;
      }

      return DateTime.fromISO(date, {
        zone: this.config.timezone,
        locale: 'en-GB',
      }).toFormat(format);
    }
  }
}
